<template>
  <div>
    <ProjectManagementPage />
  </div>
</template>
<script>
import ProjectManagementPage from "./component/projectManagementPage.vue";
export default {
  components: {
    ProjectManagementPage,
  },
};
</script>
